import { useState } from "react";
import clsx from "clsx";
import { Send, Loader2 } from "lucide-react";
import { api } from "../../api";
import { useAuth } from "../../auth";
import { useToast } from "../../ui/toast";

// Intake-Composer — VERBATIM aus ProjectIntake.tsx (submit Zeile 89-106 +
// Textarea Zeile 110-133) extrahiert. Wird vom Intake-Tab UND von der Kanban-
// „Ingest"-Spalte („+ Idee einwerfen") genutzt. onCreated feuert nach dem POST
// (Tab: Liste neu laden; Kanban: Board refetchen).
export default function IntakeComposer({
  projectId,
  onCreated,
  compact = false,
}: {
  projectId: string;
  onCreated: () => void;
  compact?: boolean;
}) {
  const { username } = useAuth();
  const toast = useToast();
  const [raw, setRaw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const text = raw.trim();
    if (!text) return;
    setBusy(true);
    try {
      await api.post(`/projects/${projectId}/intakes`, {
        raw_text: text,
        created_by: username,
      });
      setRaw("");
      onCreated();
      toast.ok("Intake angelegt", "Der Planner arbeitet ihn aus.");
    } catch (e: any) {
      toast.err("Intake fehlgeschlagen", e?.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className={clsx(
        "bg-surface border border-border rounded-lg space-y-2",
        compact ? "p-2.5" : "p-3"
      )}
    >
      <label className="text-[11px] uppercase tracking-wider text-text-3">
        Neuer Intake
      </label>
      <textarea
        value={raw}
        onChange={(e) => setRaw(e.target.value)}
        rows={compact ? 4 : 3}
        placeholder="Beschreibe in Rohsprache, was gebaut/geändert werden soll…"
        aria-label="Intake-Rohtext"
        className="w-full px-3 py-2 rounded-md border border-border bg-surface-2 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-brand-500/40"
      />
      <div className="flex justify-end">
        <button
          onClick={submit}
          disabled={busy || !raw.trim()}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm disabled:opacity-50"
        >
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}
          Senden
        </button>
      </div>
    </div>
  );
}
